/**
 * Cab Module – User's cab bookings at /cabs/my-bookings.
 */

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaCar } from "react-icons/fa";

const API_BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "";

export default function CabMyBookings() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/cab/user/my-bookings`, { withCredentials: true })
      .then((res) => setList(res.data?.data || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
          <FaCar className="text-blue-600" />
          My Cab Bookings
        </h1>
        <Link to="/cabs/search" className="text-blue-600 hover:underline mb-4 inline-block">Book another cab</Link>
        {list.length === 0 ? (
          <p className="text-gray-500">No cab bookings yet.</p>
        ) : (
          <div className="space-y-4">
            {list.map((b) => (
              <div key={b._id} className="bg-white rounded-xl shadow p-4">
                <p><strong>{b.bookingReference}</strong></p>
                <p>{b.pickupAddress} → {b.dropAddress}</p>
                <p>₹ {b.totalAmount} · {b.status}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
